import {createSelector} from "reselect";
import {getAccounts, getContracts} from "./SimpleSelectors";
import {_account, _contract, _orderCta} from "./GetParam";


export const getContractByParamOrAccount = createSelector(
    [getContracts],
    (contracts) => {
        if (_contract) {
            return _contract;
        } else if (_account) {
            return Object.keys(contracts).find((contractId) => {
                return (contracts[contractId] && contracts[contractId].sourceUid) + '' === _account;
            })
        }
    }
)

export const getContractBillingPeriodNormalized = createSelector(
    [getContracts, getContractByParamOrAccount],
    (contracts, currentContract) => {

        const billingPeriodMappingReverse = {
            0: 0,
            1: 1,
            3: 2,
            6: 3,
            12: 4
        }

        return (contracts[currentContract] && billingPeriodMappingReverse[contracts[currentContract].billingPeriod]) || 0;
    }
)



/** WEBPACK FOOTER **
 ** ./src/selectors/Contract.js
 **/